import type { ContentTestimonial } from "@/types/content";

export default function TestimonialCard({ item }: { item: ContentTestimonial }) {
  return (
    <article className="reveal h-full flex flex-col rounded-lg bg-background-50 border border-background-200/80 p-5 md:p-6">
      <div className="flex items-center gap-1 text-secondary-500" aria-label={`评分 ${item.rating} 分`}>
        {Array.from({ length: 5 }).map((_, index) => (
          <i
            key={index}
            className={`w-4 h-4 flex items-center justify-center text-sm ${
              index < item.rating ? "ri-star-fill" : "ri-star-line text-background-400"
            }`}
          />
        ))}
      </div>

      <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">“{item.content}”</p>

      <div className="mt-5 pt-4 border-t border-background-200/80 flex items-center gap-3">
        <span
          className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-800 text-sm font-medium"
          aria-hidden="true"
        >
          {item.name.slice(0, 1)}
        </span>
        <span className="flex flex-col">
          <span className="text-sm text-foreground-900">{item.name}</span>
          <span className="text-xs text-foreground-500">{item.role}</span>
        </span>
      </div>
    </article>
  );
}